import * as React from "react"
import { Link } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons"

import logo from "../images/pemalex_logo_sans_symbol.png"
import { FOOTER_ID } from "./scroll"
import { WHATSAPP_URL } from "./whatsapp"
import * as footerStyles from "./footer.module.css"

const MAPS_URL =
  "https://maps.google.com/?q=Av.+Dr.+Mendel+Steinbruch,+km+7,+Maracanaú-CE"

// Scroll rather than navigate, so there is no anchor target to maintain on
// every page. Honours the OS reduced-motion setting.
function scrollToTop() {
  const reduced =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  window.scrollTo({ top: 0, behavior: reduced ? "auto" : "smooth" })
}

/* The id is the anchor "Contato" in the navbar lands on. It sits on the footer
   itself, so every page that renders one is reachable at /#contato. */
export default function Footer() {
  return (
    <footer id={FOOTER_ID} className={footerStyles.footer}>
      <div className={footerStyles.wrap}>
        <div className={footerStyles.main}>
          <div>
            <Link to="/" className={footerStyles.word}>
              <img src={logo} alt="Pemalex" />
            </Link>
            <p className={footerStyles.tag}>
              Indústria têxtil · Maracanaú, Ceará
            </p>
          </div>
          <div className={footerStyles.contact}>
            <a
              className={footerStyles.addr}
              href={MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Av. Dr. Mendel Steinbruch, km 7, s/n
              <br />
              Maracanaú — Ceará
            </a>
            <a href="tel:+5585994320868">+55 (85) 99432-0868</a>
            <a href="mailto:contato@pemalex.com.br">contato@pemalex.com.br</a>
            <a
              className={footerStyles.ig}
              href="https://instagram.com/pemalextextil"
              target="_blank"
              rel="noopener noreferrer"
            >
              @pemalextextil
            </a>
            <a
              className={footerStyles.whats}
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon
                icon={faWhatsapp}
                className={footerStyles.whatsIcon}
              />
              Falar no WhatsApp
            </a>
          </div>
        </div>

        <div className={footerStyles.rule}></div>

        <div className={footerStyles.bottom}>
          <div className={footerStyles.amare}>
            <span className={footerStyles.amareTag}>Estamparia</span>
            {/* The Amaré section of the one-pager, not the /amare/ route it
                used to be — the route still exists for links shared before
                the site was merged, but nothing on the site points at it. */}
            <Link to="/#amare" className={footerStyles.amareName}>
              Amaré Design
            </Link>
            <a
              className={footerStyles.amareLink}
              href="mailto:amare@pemalex.com.br"
            >
              amare@pemalex.com.br
            </a>
            <a
              className={`${footerStyles.amareLink} ${footerStyles.amareIg}`}
              href="https://instagram.com/amaredesign"
              target="_blank"
              rel="noopener noreferrer"
            >
              @amaredesign
            </a>
          </div>
          <div className={footerStyles.meta}>
            <span>
              © 2026 Pemalex Indústria e Comércio · Feito com{" "}
              <span className={footerStyles.heart}>&hearts;</span> no Ceará
            </span>
            <button
              type="button"
              className={footerStyles.toTop}
              onClick={scrollToTop}
            >
              Voltar ao topo <span className={footerStyles.up}>&uarr;</span>
            </button>
          </div>
        </div>
      </div>
    </footer>
  )
}
